import styled from 'styled-components';

export const Editor = styled.div`
  position: ${p => (p.isFixed ? 'fixed' : 'relative')};
  background: ${p => (p.isFixed ? '#efefef' : 'transparent')};
  height: ${p => (p.isFixed ? '50px' : 'auto')};
  width: ${p => (p.isFixed ? '50px' : 'auto')};
  padding: ${p => (p.isFixed ? '10px' : 0)};
  bottom: 0;
  left: 0;
  white-space: nowrap;
  z-index: 101;
  cursor: pointer;
`;

export const Menu = styled.div`
  position: absolute;
  top: 0;
  left: 100%;
  z-index: 101;
  width: calc(100vw - 50px);
  overflow-x: auto;
  overscroll-behavior: contain;

  background: ${p => p.theme.bg.secondary};
  padding: 8px;
  padding-right: 50px;

  > button {
    margin-left: 10px;
  }
`;
